import { gql } from "@apollo/client";

export const DOWNLOAD_CONTRACT_REQUIRED_DOCUMENT_TEMPLATE_QUERY = gql`
  query downloadContractRequiredDocumentTemplate(
    $quoteId: Int!
    $contractId: Int!
    $contractSiteId: Int!
    $guarantorId: Int
    $guarantorName: String
    $clientId: Int
    $documentTemplateId: Int!
    $templateContentType: String!
  ) {
    downloadContractRequiredDocumentTemplate(
      quoteId: $quoteId
      contractId: $contractId
      contractSiteId: $contractSiteId
      guarantorId: $guarantorId
      guarantorName: $guarantorName
      clientId: $clientId
      documentTemplateId: $documentTemplateId
      templateContentType: $templateContentType
    ) {
      name
      content
    }
  }
`;

export const DOWNLOAD_CONTRACT_REQUIRED_DOCUMENT_TEMPLATES_QUERY = gql`
  query downloadContractRequiredDocumentTemplates(
    $quoteId: Int!
    $transactionId: String!
    $contractId: Int!
    $contractSiteId: Int!
    $clientId: Int!
  ) {
    downloadContractRequiredDocumentTemplates(
      quoteId: $quoteId
      transactionId: $transactionId
      contractId: $contractId
      contractSiteId: $contractSiteId
      clientId: $clientId
    ) {
      name
      content
    }
  }
`;
